import SelectChallengeBlock from './SelectChallengeBlock';

export default SelectChallengeBlock;
